<template>
  <div class="popup-modal">
    <div class="popup-modal-wrapper">
      <div class="popup-modal-dialog">
        <div class="popup-modal-content">
          <div class="popup-modal-header">
            <slot name="heading" />
            <a href="#" class="popup-modal-close-button" @click.prevent="onClickCloseButton">
              <img :src="crossMark" />
            </a>
          </div>
          <div class="popup-modal-body">
            <slot name="body" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from '@vue/composition-api';
import crossMark from '../../images/icon-cross.png';

export default defineComponent({
  name: 'PopupModal',
  emits: {
    close: () => true,
  },
  setup(_props, { emit }) {
    const onClickCloseButton = () => {
      emit('close');
    };
    return {
      onClickCloseButton,
      crossMark,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';

.popup-modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: $z-index-popup;
  outline: 0;
}
.popup-modal-wrapper {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
}
.popup-modal-dialog {
  position: relative;
  margin: auto 12px;
  width: 100%;
}
.popup-modal-content {
  width: 650px;
  margin: 0 auto;
  border-radius: 2px;
  position: relative;
  background-color: #ffffff;
  background-clip: padding-box;
  outline: 0;
  box-shadow: 0 5px 15px rgb(0 0 0 / 50%);

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.popup-modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}

.popup-modal-body {
  position: relative;
  padding: 20px;
}

.popup-modal-close-button {
  position: absolute;
  right: 20px;
  color: #a4a9ae;
  img {
    width: 14px;
  }
}
</style>
